/* eslint-disable react-hooks/exhaustive-deps */

import Spinner from "../../../../components/Spinner";

import { TimesheetStoreProvider } from "./store";
import useTimeSheetStore from "./store/useStore";

import "./index.scss";

import { TitleTimeSheet } from "./components/TitleComponent";
import TableTimeSheet from "./components/TableTimeSheet";
import { useEffect } from "react";

export default function Timesheet() {
  return (
    <TimesheetStoreProvider>
      <TimeSheetComponent />
    </TimesheetStoreProvider>
  );
}

function TimeSheetComponent() {
  const { needSpinner, setNeedSpinner } = useTimeSheetStore();

  useEffect(() => {
    setTimeout(() => {
      setNeedSpinner(false);
    }, 1000);
  }, []);

  return (
    <Spinner status={needSpinner}>
      <div className="flex flex-col py-0 px-8 sm:min-h-40rem w-full sm:mt-32">
        <TitleTimeSheet />
        <TableTimeSheet />
      </div>
    </Spinner>
  );
}
